module.exports = __webpack_public_path__ + "static/media/popup.542969e6.svg";